module.exports = __webpack_public_path__ + "media/images/new/cell_coverage_maps-5b4768252e922c97bb3b2dcc9f355bbd.jpg";